/* global axios */
import ApiClient from './ApiClient';

class NonSalesAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getAllForConversation(conversationId) {
    return axios.get(`${this.url}/${conversationId}/non_sales`);
  }

  createForConversation(conversationId, payload) {
    return axios.post(`${this.url}/${conversationId}/non_sales`, payload);
  }
}

export default new NonSalesAPI();
